import React from 'react';
import { Group, Paper, Select, Text } from '@mantine/core';

export default function ViewAsSelect({ options, value, onChange }) {
  if (options.length === 0) {
    return null;
  }

  return (
    <Paper p='sm' mb='sm' withBorder>
      <Group gap='sm' align='center'>
        <Text fw={600}>View as</Text>
        <Select
          aria-label='View as'
          data={options.map(({ value: optionValue, label }) => ({ value: optionValue, label }))}
          value={value}
          onChange={onChange}
          allowDeselect={false}
          searchable
          style={{ flex: 1, maxWidth: 320 }}
        />
      </Group>
    </Paper>
  );
}
